<template>
  <div class="field">
    <div class="label-wrapper">
      <label
        v-if="label"
        class="label"
        v-html="label"
      />
    </div>
    <div class="control">
      <input
        ref="currencyInput"
        type="text"
        :placeholder="placeholder"
        :class="extraClass"
        :name="name"
        v-model="value"
        class="input"
        @keyup="formatCurrency"
        @blur="formatCurrency('blur')"
      >
    </div>
    <p
      v-if="message"
      :class="message.class"
      class="help"
      v-text="message.value"
    />
  </div>
</template>

<script>
const formatNumber = (n) => {
  // format number 1000000 to 1,234,567
  return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export default {
  name: 'CurrencyField',
  data () {
    return {
      value: '',
      centsValue: 0
    }
  },
  props: {
    initialValue: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    extraClass: {
      type: String,
      default: ''
    },
    label: {
      type: [Boolean, String],
      default: false
    },
    message: {
      type: [Boolean, Object],
      default: false
    }
  },
  mounted () {
    if (this.initialValue > 0) {
      this.formatInitialValue(this.initialValue)
    }
  },
  watch: {
    initialValue () {
      this.formatInitialValue(this.initialValue)
    }
  },
  computed: {
    isPasswordInput () {
      return this.type === 'password'
    }
  },
  methods: {
    emitChange () {
      this.$emit('changedValue', this.value)
    },
    formatInitialValue (value) {
      this.centsValue = this.initialValue

      value = (value / 100).toString()
      let [left, right] = value.split('.')

      if (typeof right === 'undefined') {
        right = '00'
      }

      this.value = `$${formatNumber(left)}.${right}`
    },
    formatCurrency (blur) {
      //  Forked from https://codepen.io/559wade/pen/LRzEjj
      const input = this.$refs.currencyInput

      // don't validate empty input
      if (this.value === '') { return }

      // original length
      var originalLen = this.value.length

      // initial caret position
      var caretPos = input.selectionStart

      // check for decimal
      if (this.value.indexOf('.') >= 0) {
        // get position of first decimal
        // this prevents multiple decimals from
        // being entered
        var decimalPos = this.value.indexOf('.')

        // split number by decimal point
        var leftSide = this.value.substring(0, decimalPos)
        var rightSide = this.value.substring(decimalPos)

        // add commas to left side of number
        leftSide = formatNumber(leftSide)

        // validate right side
        rightSide = formatNumber(rightSide)

        // On blur make sure 2 numbers after decimal
        if (blur === 'blur') {
          rightSide += '00'
        }

        // Limit decimal to only 2 digits
        rightSide = rightSide.substring(0, 2)

        // join number by .
        this.value = '$' + leftSide + '.' + rightSide
      } else {
        // no decimal entered
        // add commas to number
        // remove all non-digits
        this.value = formatNumber(this.value)

        this.value = '$' + this.value

        // final formatting
        if (blur === 'blur') {
          this.value += '.00'
        }
      }

      // put caret back in the right position
      let updateLen = this.value.length
      caretPos = updateLen - originalLen + caretPos
      input.setSelectionRange(caretPos, caretPos)

      if (blur === 'blur') {
        this.emitCents(this.value)
      }
    },
    emitCents (value) {
      let total = 0

      let [left, right] = value.split('.')
      left = parseInt(left.replace(/\D/, '').split(',').join('')) * 100
      right = parseInt(right)

      total = left + right

      if (!isNaN(total)) {
        this.$emit('changedValue', total)
      }
    }
  }
}
</script>
